// extracted by mini-css-extract-plugin
export var currencyInput = "_kv-1";
export var currencySymbol = "_kv-0";